export default __webpack_public_path__ + "static/media/mode-56.a67ae556.svg";